import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-seo-off-page-prospects-form',
  templateUrl: './seo-off-page-prospects-form.component.html',
  styleUrls: ['./seo-off-page-prospects-form.component.css'],
})
export class SeoOffPageProspectsFormComponent {
  url: string = 'seoOffpageProspects';
  id!: string;
  form!: FormGroup;
  isViewOnly: boolean = false;
  campaigns: Array<any> = [];

  prospectTypes = [
    { value: 'directory', label: 'Directory' },
    { value: 'local_citation', label: 'Local Citation' },
    { value: 'blog', label: 'Blog' },
    { value: 'news', label: 'News' },
    { value: 'partner', label: 'Partner' },
    { value: 'business_listing', label: 'Business Listing' },
    { value: 'community', label: 'Community' },
    { value: 'other', label: 'Other' },
  ];

  outreachStatuses = [
    { value: 'pending', label: 'Pending' },
    { value: 'contacted', label: 'Contacted' },
    { value: 'replied', label: 'Replied' },
    { value: 'negotiating', label: 'Negotiating' },
    { value: 'approved', label: 'Approved' },
    { value: 'rejected', label: 'Rejected' },
    { value: 'published', label: 'Published' },
  ];

  outreachChannels = [
    { value: 'email', label: 'Email' },
    { value: 'form', label: 'Form' },
    { value: 'manual', label: 'Manual' },
    { value: 'partner', label: 'Partner' },
    { value: 'other', label: 'Other' },
  ];

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/marketing',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/marketing/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/marketing/social/strategy',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'GEO',
      route: '',
    },
    
  ];

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.getCampaigns();
    this.route.params.subscribe((params: Params) => {
      this.id = params['id'];
      if (this.id) {
        this.getData();
      }
    });

    this.isViewOnly = this.router.url.includes('/view/');
    if (this.isViewOnly) {
      this.form.disable();
    }
  }

  initForm(): void {
    this.form = this.fb.group({
      campaignId: ['', [Validators.required]],
      domain: ['', [Validators.required]],
      sourceUrl: [''],
      prospectName: ['', [Validators.required]],
      prospectType: ['', [Validators.required]],
      country: [''],
      city: [''],
      relevanceScore: [0],
      authorityScore: [0],
      trustScore: [0],
      spamRisk: [0],
      contactName: [''],
      contactEmail: [''],
      contactFormUrl: [''],
      outreachStatus: ['pending'],
      outreachChannel: ['manual'],
      suggestedAnchor: [''],
      targetUrl: ['', [Validators.required]],
      targetKeyword: ['', [Validators.required]],
      notes: [''],
      followUpAt: [null],
    });
  }

  getCampaigns(): void {
    this.dataService.getData('seoOffPageCampaigns').subscribe((response) => {
      this.campaigns = response.data;
    });
  }

  getData(): void {
    this.dataService.getData(`${this.url}/${this.id}`).subscribe((response) => {
      console.log('response 1', response);
      const data = response.data;
      this.form.patchValue({
        campaignId: data.campaignId?._id || data.campaignId,
        domain: data.domain,
        sourceUrl: data.sourceUrl,
        prospectName: data.prospectName,
        prospectType: data.prospectType,
        country: data.country,
        city: data.city,
        relevanceScore: data.relevanceScore,
        authorityScore: data.authorityScore,
        trustScore: data.trustScore,
        spamRisk: data.spamRisk,
        contactName: data.contactName,
        contactEmail: data.contactEmail,
        contactFormUrl: data.contactFormUrl,
        outreachStatus: data.outreachStatus,
        outreachChannel: data.outreachChannel,
        suggestedAnchor: data.suggestedAnchor,
        targetUrl: data.targetUrl,
        targetKeyword: data.targetKeyword,
        notes: data.notes,
        followUpAt: data.followUpAt
          ? new Date(data.followUpAt).toISOString().substring(0, 10)
          : null,
      });
      if (this.isViewOnly) {
        this.form.disable();
      }
    });
  }

  onSubmit(): void {
    if (this.form.invalid) {
      return;
    }

    if (this.id) {
      this.updateData();
    } else {
      this.createData();
    }
  }

  createData(): void {
    this.dataService
      .postData(`${this.url}/add`, this.form.value)
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.router.navigateByUrl('marketing/seo/offPageProspects');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  updateData(): void {
    this.dataService
      .putData(`${this.url}/edit/${this.id}`, this.form.value)
      .subscribe((response) => {
        if (response.rst) {
          this.messageService.add(response.msg, 'info');
          this.router.navigateByUrl('marketing/seo/offPageProspects');
        } else {
          this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  goBack(): void {
    this.router.navigateByUrl('marketing/seo/offPageProspects');
  }

  isFieldInvalid(field: string) {
    return (
      this.form.get(field)?.invalid &&
      (this.form.get(field)?.dirty || this.form.get(field)?.touched)
    );
  }
}
